module.exports = __webpack_public_path__ + "static/img/infoCover1.4c6bfd4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/infoCover1.jpg
// module id = 90
// module chunks = 1 4